module.exports = __webpack_public_path__ + "img/ico31.28cf3ebf.jpg";